<template>
  <Stack class="document-portal-side">
    <Stack
      class="sidebar-content"
      gap="4"
    >
      <Stack gap="4">
        <Stack gap="1">
          <Title size="4">
            <span
              class="home"
              @click="clientPortalStore.returnHome()"
            >
              Your Documents
            </span>
          </Title>
          <Subtitle size="3_5">
            Let's gather your documents, one step at a time
          </Subtitle>
        </Stack>
      </Stack>

      <!-- Document Sections -->
      <Stack
        class="document-sections"
        gap="2"
      >
        <Stack
          v-for="section in clientPortalStore.checklistSectionsExcludingOther"
          :key="section.key"
          gap="1"
        >
          <MenuLabel class="section-title">
            {{ section.name }} Documents
          </MenuLabel>

          <!-- Individual Documents in Section -->
          <Menu>
            <MenuList>
              <DocumentPortalItem
                v-for="document in section.documents"
                :key="`${section.key}-${document.sequentialNumber}`"
                :document="document"
                :section="section"
              />
            </MenuList>
          </Menu>
        </Stack>

        <MenuDivider />

        <MenuItem
          :active="clientPortalStore.currentStep === 'others'"
          :count="clientPortalStore.otherDocuments.length"
          @click="clientPortalStore.setCurrentStep('others')"
        >
          Other Documents
        </MenuItem>
      </Stack>

      <Button
        variant="success"
        :disabled="!clientPortalStore.processComplete"
        @click="clientPortalStore.moveToEnd()"
      >
        Finish
      </Button>

      <div class="security-notice">
        <Icon
          class="security-icon"
          icon="fas fa-shield-alt"
          size="3"
        />
        <p>Your documents are securely stored and encrypted.<br>Only you and your advisor have access to them.</p>
      </div>
    </Stack>

    <AdvisorCard
      v-if="clientPortalStore.advisorInfo"
      :advisor-info="clientPortalStore.advisorInfo"
      :firm-info="clientPortalStore.firmInfo"
    />

    <!-- User Status -->
    <ClientPortalUserStatus />
  </Stack>
</template>

<script setup>
import { Button, Icon, Menu, MenuLabel, MenuList, MenuItem, MenuDivider, Stack, Subtitle, Title } from '@stakeui';
import AdvisorCard from '../../example/components/AdvisorCard.vue';
import ClientPortalUserStatus from '../../example/components/ClientPortalUserStatus.vue';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';
import DocumentPortalItem from './DocumentPortalItem.vue';

const clientPortalStore = useClientPortalStore();
</script>

<style scoped>
.document-portal-side {
  background-color: #FCFCFD;
  border: 1px solid var(--stk-text-90);
  border-width: 0 1px 0 0;
  width: 17.5em;
  flex-shrink: 0;
  flex-grow: 0;
  padding: 2em;
  display: flex;
  flex-direction: column;
  gap: 2em;
  justify-content: space-between;
  overflow-y: auto;
}

.section-header {
  font-size: 0.875em;
  font-weight: 500;
  color: var(--stk-text-50);
}

.sidebar-content {
  flex-grow: 1;
}

.home:hover {
  cursor: pointer;
  text-decoration: underline;
}

.security-notice {
  color: var(--stk-text-50);
  display: flex;
  font-size: 0.75em;
  gap: 0.25em;
  padding: 1em 1em;
  border-radius: 0.75em;
  margin: 0 -1rem;
}

.security-icon {
  opacity: 0.5;
}

@media screen and (max-width: 60rem) {
  .document-portal-side {
    width: auto;
    border-width: 0 0 1px;
  }
}
</style>
